// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2GrmM","label":"Section_label__ekbcN","contentWrap":"Section_contentWrap__1Y35o","footer":"Section_footer__1jPo_","footerInner":"Section_footerInner__32rhW"};